import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'
import { ApiList } from '@/api/v2/types/json-api'
import { ContextType } from '@/api/v2/types/aggregation-result'

export interface BusinessRuleResultAttrs {
  id: number
  businessRuleId: number
  resultValue: number | string
  contextId: number
  contextType: ContextType
  businessDate: string
  isDirty: boolean
  createdAt: string
  updatedAt: string
}

export type BusinessRuleResultListResponse = ApiList<BusinessRuleResultAttrs, 'businessRuleResult'>

export async function saveBusinessRuleResult({
  aggregationContainerId,
  aggregationId,
  businessRuleId,
  businessDate,
  contextType,
  contextId,
  resultValue,
}: {
  aggregationContainerId: number
  aggregationId: number
  businessRuleId: number
  businessDate: string
  contextType: string
  contextId: number
  resultValue: number | string
}): Promise<BusinessRuleResultAttrs[]> {
  const res = await axiosIns.put<BusinessRuleResultListResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/business_rule_results/${businessRuleId}/save`,
    snakecaseKeys({
      aggregationContainerId,
      aggregationId,
      businessRuleId,
      businessDate,
      contextType,
      contextId,
      resultValue,
    }),
  )

  return res.data.data.data.map(r => r.attributes)
}
